



import {Component, Prop, Vue} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";

@Component({
  components: {SvgRender}
})
export default class RecentSearch extends Vue {
  @Prop(String) rightIcon?: string
  @Prop(String) textSearch?: string
  @Prop(String) color?: string
  @Prop(String) fontWeight?: string
  @Prop(String) search?: string
  @Prop({required: false, type: Boolean, default: false}) hasImg!: boolean


  private onClickDeleteSearchRecent(): void {
    this.$emit('onClickDeleteSearchRecent')
  }

  private onClickSearchRecent(): void {
    this.$emit('onClickSearchRecent')
  }
}
